import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import uz from './locales/uz.json';
import ru from './locales/ru.json';
import en from './locales/en.json';
import fr from './locales/fr.json';

import { DEFAULT_LANGUAGE, splitLanguageFromPath } from './utils/language';

// Язык берём из URL ещё до монтирования React: иначе на /ru страница сначала
// отрисуется по-узбекски и только потом переключится — заметная вспышка,
// которая вдобавок затирает пререндеренную разметку.
const initialLanguage =
    typeof window === 'undefined'
        ? DEFAULT_LANGUAGE
        : splitLanguageFromPath(window.location.pathname).language;

const resources = {
    uz: { translation: uz },
    ru: { translation: ru },
    en: { translation: en },
    fr: { translation: fr }
};

i18n
    .use(initReactI18next)
    .init({
        resources,
        lng: initialLanguage, // из URL; язык по умолчанию — узбекский
        fallbackLng: 'ru',
        interpolation: {
            escapeValue: false
        },
        react: {
            useSuspense: false
        }
    });

export default i18n;
